<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
          <a-form-item label="基地">
            <j-dict-select-tag  ref="baseSelectRef" :is-choose-first="true" v-model="queryParam.roleType" placeholder="请选择基地"   dictCode="bus_inspection_base,base,base_no,status = '1'"  ></j-dict-select-tag>
          </a-form-item>
          <a-form-item label="角色名称">
            <j-dict-select-tag  ref="roleSelectRef" v-model="queryParam.roleId" placeholder="请选择角色名称"  ></j-dict-select-tag>
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡检分组用户配置表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="userName"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">
        <template v-for="weekname in weekColumnsArr"  :slot="weekname" slot-scope="text, record">
          <a  @click="handleGroupEdit(record,weekname)" :key="weekname" >
            <span  v-if="record[weekname]"  >{{record[weekname]}}</span>
            <span  v-else  >编辑</span>
          </a>
        </template>
      </a-table>
    </div>

    <workshop-group-user-modal ref="modalForm" @ok="modalFormOk"></workshop-group-user-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkshopGroupUserModal from './modules/WorkshopGroupUserModal'
  import { getAction,postAction } from '@/api/manage'

  export default {
    name: "BusInspectionGroupUserConfigList",
    mixins:[JeecgListMixin],
    components: {
      WorkshopGroupUserModal
    },
    data () {
      return {
        description: '巡检分组用户配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'巡查人员',
            align:"center",
            dataIndex: 'userName'
          },
          {
            title:'周一',
            align:"center",
            key:"mon",
            scopedSlots: { customRender: 'mon' }
          },
          {
            title:'周二',
            align:"center",
            key: 'tues',
            scopedSlots: { customRender: 'tues' }
          },
          {
            title:'周三',
            align:"center",
            key: 'wed',
            scopedSlots: { customRender: 'wed' }

          },
          {
            title:'周四',
            align:"center",
            key: 'thur',
            scopedSlots: { customRender: 'thur' }
          },
          {
            title:'周五',
            align:"center",
            key: 'fri',
            scopedSlots: { customRender: 'fri' }

          },
          {
            title:'周六',
            align:"center",
            key: 'sat',
            scopedSlots: { customRender: 'sat' }

          },
          {
            title:'周日',
            align:"center",
            key: 'sun',
            scopedSlots: { customRender: 'sun' }

          },
        ],
        url: {
          list: "/group/busInspectionGroupUserConfig/list",
          delete: "/group/busInspectionGroupUserConfig/delete",
          deleteBatch: "/group/busInspectionGroupUserConfig/deleteBatch",
          exportXlsUrl: "/group/busInspectionGroupUserConfig/exportXls",
          importExcelUrl: "group/busInspectionGroupUserConfig/importExcel",
        },
        dictOptions:{},
        disableMixinCreated:true,
        weekColumnsArr:["mon","tues","wed","thur","fri","sat","sun"]
      }
    },
    watch:{
      "queryParam.roleType":{
        handler(newVal){
          console.log( "queryParam.roleType")
          console.log(newVal)
          let params={
            roleType:newVal
          }
          this.loading = true;
          getAction("/inspection/role/list", params).then((res) => {
              if (res.success) {
                let optionsTemps=[]
                optionsTemps = res.result.records.filter((item)=>{
                  if(item.roleCode!='inspectionAdminXiamen'&&item.roleCode!='inspectionAdminSiyang'&&item.roleCode!='business_siyang'&&item.roleCode!='business_xiamen'&&item.roleCode!='5S_xiamen'&&item.roleCode!='5S_siyang'){
                    return true
                  }else{
                    return false
                  }
                }).map((item)=>{
                  return {
                    label:item.roleName,
                    value:item.roleId
                  }
                })
                this.$refs.roleSelectRef.setCurrentDictOptions(optionsTemps)
                if(optionsTemps.length>0){
                  this.$set(this.queryParam,"roleId",optionsTemps[0].value)
                }
              }else{
                  this.$message.warning(res.message)
              }  
              if (res.code === 510) {
                  this.$message.warning(res.message)
              }
              this.loading = false;
          })
        }
      },
      "queryParam.roleId":{
        handler(newVal){
          this.searchQuery();
        }
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig(){
      },
      loadData (arg) {
          if (!this.url.list) {
              this.$message.error("请设置url.list属性!")
              return
          }
          //加载数据 若传入参数1则加载第一页的内容
          if (arg === 1) {
              this.ipagination.current = 1;
          }
          var params = this.getQueryParams();//查询条件
          this.loading = true;
          this.dataSource=[]
          getAction(this.url.list, params).then((res) => {
              if (res.success) {
                  // this.dataSource = res.result.records;
                  let dataSourceTemp=[]
                  dataSourceTemp=res.result.records.map((item)=>{
                    let elementData={}
                    elementData.userName=item.user.realname;
                    elementData.userNo=item.user.username;
                    elementData.roleId=params.roleId;
                    elementData.baseNo=params.roleType;
                    elementData.base=this.$refs.baseSelectRef.getSelectLabels();
                    if(item.group){
                      for (const iterator of item.group) {
                        elementData[this.numberChangeWeek(iterator.workDay)]=iterator.groupName;
                        if(elementData.weekObj){
                          elementData.weekObj[this.numberChangeWeek(iterator.workDay)]=iterator;
                        }else{
                          elementData.weekObj={};
                          elementData.weekObj[this.numberChangeWeek(iterator.workDay)]=iterator;
                        }
                      }
                    }
                    return elementData
                  })
                  this.dataSource = dataSourceTemp;
                  this.ipagination.total = res.result.total;
                  this.pageRefresh ++
              }else{
                  this.$message.warning(res.message)
              }  
              if (res.code === 510) {
                  this.$message.warning(res.message)
              }
              this.loading = false;
          })
      },
      handleGroupEdit(record,weekname){
        record.workDay=this.weekChangeNumber(weekname);
        if(record.weekObj&&record.weekObj[weekname]){
          record.groupId=record.weekObj[weekname].groupId
        }else{
          record.groupId=undefined
          record.groupName=undefined
        }
        this.$refs.modalForm.add(record);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
      numberChangeWeek(value){
        switch (value) {
          case 1:
            return "sun"
          case 2:
            return "mon"
          case 3:
            return "tues"
          case 4:
            return "wed"
          case 5:
            return "thur"
          case 6:
            return "fri"
          case 7:
            return "sat"
          default:
            return ""
        }
      },
      weekChangeNumber(value){
        switch (value) {
          case "sun":
            return 1
          case "mon":
            return 2
          case "tues":
            return 3
          case "wed":
            return 4
          case "thur":
            return 5
          case "fri":
            return 6
          case "sat":
            return 7
          default:
            return ""
        }
      }
      
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
  /deep/.row-choose-bgblue{
    background: #e6f7ff !important;
  }
</style>